<template>
  <div class="refiner" data-testid="workspace-document-search-refiner">
    <label class="refiner__label">{{ label }}</label>
    <div
      v-for="([value, count], index) in sortedRefinerEntries"
      :key="`${value}-${index}`"
      class="refiner__option"
    >
      <PVCheckbox
        :model-value="isChecked(value)"
        :binary="true"
        @update:model-value="(checked) => onToggle(value, !!checked)"
      />
      <span>{{ getDisplayValue(value) }} ({{ count }})</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import PVCheckbox from 'primevue/checkbox';
  import { useI18n } from 'vue-i18n';

  const props = defineProps<{
    modelValue: string[];
    label: string;
    refinerValues: Record<string, number>;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string[]): void;
  }>();
  const { t } = useI18n();
  const sortedRefinerEntries = computed(() =>
    Object.entries(props.refinerValues).sort(([firstValue], [secondValue]) => {
      if (firstValue === 'null') {
        return -1;
      }
      if (secondValue === 'null') {
        return 1;
      }
      return 0;
    }),
  );

  function isChecked(value: string): boolean {
    return props.modelValue.includes(value);
  }

  function onToggle(value: string, checked: boolean): void {
    if (checked) {
      emit('update:modelValue', [...new Set([...props.modelValue, value])]);
    } else {
      emit(
        'update:modelValue',
        props.modelValue.filter((item) => item !== value),
      );
    }
  }

  function getDisplayValue(value: string): string {
    return value === 'null' ? t('workspaceDocuments.picker.notPresent') : value;
  }
</script>

<style scoped lang="scss">
  .refiner {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;

    &__label {
      font-weight: 700;
    }

    &__option {
      display: flex;
      align-items: center;
      column-gap: 0.5rem;
    }
  }
</style>
